import React, { FunctionComponent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSwipeable } from 'react-swipeable';
import { IBindingAction, IBindingCallback1 } from '../../../../common/models/callback';
import Icon from '../../../../components/Icon';
import RegularButton from '../../../../components/RegularButton';
import TextArea from '../../../../components/TextArea';
import { declineQuestion2 } from '../../containers/Intro/utils';

interface IProps {
  declineSurvey?: IBindingCallback1<string>;
  onRejectSurvey: IBindingAction;
  onGoBack: IBindingAction;
}

const SecondDecline: FunctionComponent<IProps> = ({ declineSurvey, onRejectSurvey, onGoBack }) => {
  const [declineReason, setDeclineReason] = useState('');

  const onDecline = () => {
    if (declineSurvey) {
      declineSurvey(declineReason);
    }
    onRejectSurvey();
  };

  const swipeHandler = useSwipeable({
    onSwipedLeft: () => {
      if (declineReason.trim()) onDecline();
    },
    onSwipedRight: onGoBack,
    trackMouse: false
  });

  return (
    <div {...swipeHandler} className="survey-page">
      <div className="survey-page-wrapper">
        <p className="survey-page-title">
          <FormattedMessage
            id="survey.declineQuestion2"
            defaultMessage={declineQuestion2}
          />
        </p>
        <FormattedMessage id="survey.declinePlaceholder" defaultMessage="Enter response here">
          {placeholder => (
            <TextArea
              size="lg"
              placeholder={placeholder as string}
              onChange={setDeclineReason}
              input={declineReason}
            />
          )}
        </FormattedMessage>
        <div className="d-flex justify-content-end mt-3">
          <RegularButton
            textIntlId="done"
            size="lg"
            defaultMessage="Done"
            icon={<Icon icon="arrowRight" />}
            disabled={!declineReason.trim()}
            onClick={onDecline}
            iconPosition="right"
          />
        </div>
      </div>
    </div>
  );
};

export default SecondDecline;
